module.exports = __webpack_public_path__ + "static/img/xiazaijietu2.04b900a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/xiazaijietu2.png
// module id = 9RlR
// module chunks = 24